module.exports = __webpack_public_path__ + "static/media/lp8.dee5f303.jpg";